/**
 * The password rule to show and check (AUTH-15): the API's published rule (GET
 * /api/v1/auth/password-policy, loaded once), so a checklist is always the rule the server applies;
 * the built-in copy of the same rule until it has loaded, or if it can't.
 */

import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { PASSWORD_RULES, rulesFromPolicy, type PasswordRule } from "../lib/passwordRules";
import { getPasswordPolicy } from "./auth";

/** `enabled: false` until a form will ask for a new password (the sign-in page only sometimes does). */
export function usePasswordRules({ enabled = true }: { enabled?: boolean } = {}): PasswordRule[] {
  const { data } = useQuery({
    queryKey: ["password-policy"],
    queryFn: getPasswordPolicy,
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
  });
  return useMemo(() => rulesFromPolicy(data) ?? PASSWORD_RULES, [data]);
}
